import React, { FC, useCallback } from "react";
import emptyAdScreenIcon from "../../../../assets/svg/emptyAdScreenIcon.svg";
import { raiseNoticeAdRequestWorkflow } from "../../utils";
import { NoticeWorkflowCards } from "../NoticeWorkflowCards";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { raiseNewRequestAction } from "../../../../store/actions/raiseAdRequest";
import { RaiseAdRequestState } from "../../../../store/types/raiseAdRequest";
import { openToast } from "../../../../Toasts";

export const DefaultDashboardScreen: FC = () => {
  const dispatch = useDispatch();
  const { selectedProductId } = useParams<{ selectedProductId: string }>();
  const { userRole } = useSelector(
    (state: { raiseAdRequest: RaiseAdRequestState }) => state.raiseAdRequest
  );

  const handleRaiseNewRequest = useCallback(() => {
    if (userRole === "designer-own-access") {
      openToast("info", "You don't have Access to create a New Request");
      return;
    }
    dispatch(raiseNewRequestAction(selectedProductId));
  }, [dispatch, selectedProductId, userRole]);
  return (
    <div className="default-dashboard">
      {/* Empty state */}
      <div className="default-dashboard__empty-state">
        <img src={emptyAdScreenIcon} alt="Empty Screen" />
        <div className="default-dashboard__empty-text">
          You don’t have any raised requests
        </div>
        <button className="btn btn--purple" onClick={handleRaiseNewRequest}>
          Raise a Request
        </button>
      </div>

      {/* Section title */}
      <div className="default-dashboard__section-title">
        How to Raise Notice Ad Request?
      </div>

      {/* Workflow rows */}
      <div className="default-dashboard__workflow-row">
        {raiseNoticeAdRequestWorkflow.slice(0, 4).map((step, index) => (
          <NoticeWorkflowCards
            key={index}
            title={step.title}
            description={step.description}
          />
        ))}
      </div>

      <div className="default-dashboard__workflow-row">
        {raiseNoticeAdRequestWorkflow.slice(4, 7).map((step, index) => (
          <NoticeWorkflowCards
            key={index}
            title={step.title}
            description={step.description}
          />
        ))}
      </div>
    </div>
  );
};
